import dayjs, { ManipulateType } from "dayjs";

import type { Frequency } from "../../types";

const FREQUENCY_OFFSETS: Record<Frequency, [number, ManipulateType]> = {
  MONTHLY:       [1,  "month"],
  QUARTERLY:     [3,  "month"],
  SEMI_ANNUALLY: [6,  "month"],
  ANNUALLY:      [1,  "year"],
};

const getNextDate = (startDate: string, frequency: Frequency): string | undefined => {
  const hasValue = startDate && frequency;

  if (!hasValue) {
    return undefined;
  }
  
  const [amount, unit] = FREQUENCY_OFFSETS[frequency];
  
  return dayjs(startDate).add(amount, unit).format("MM/DD/YYYY");
};

export default getNextDate;
